module.exports = __webpack_public_path__ + "img/question_creation_show_selection.3b16ac0f.png";